export const primaryOrSecondary = (
  a: string | null | undefined,
  b: string | null | undefined
) => (a && b ? `${a} (${b})` : a || b);
